import { ImagePreviewSize, ImagePreviewWithSize } from '../../documents/types/types';
import appClient from './AppClient';
import { endpoints } from '../../../config';

export default class ImageService {
    getImagePaths(packageId: string, indexDate: string, fromPage?: number, toPage?: number) {
        const url =
            endpoints.imageUrl + `paths/${packageId}/?fromPage=${fromPage}&toPage=${toPage}&indexDate=${indexDate}`;
        return appClient.get<string>(url);
    }

    getImageUrlFromPath(path: string, imageSize: ImagePreviewSize, indexDate: string): string {
        const url = endpoints.imageUrl + `preview/?path=${path}&imageSize=${imageSize}&indexDate=${indexDate}`;
        return url;
    }

    // eslint-disable-next-line max-len
    getImagePathsWithSizes(
        packageId: string,
        imageSize: ImagePreviewSize,
        indexDate: string,
        fromPage?: number,
        toPage?: number
    ) {
        const url =
            endpoints.imageUrl +
            `paths/${packageId}/sizes?fromPage=${fromPage}&toPage=${toPage}&indexDate=${indexDate}&imageSize=${imageSize}`;
        return appClient.get<ImagePreviewWithSize[]>(url);
    }

    getImagePreview(imageName: string, imageSize: ImagePreviewSize, indexDate: string) {
        encodeURIComponent(imageName);
        const url = endpoints.imageUrl + `preview/?path=${imageName}&imageSize=${imageSize}&indexDate=${indexDate}`;
        return appClient.get(url);
    }
}
